import { render, staticRenderFns } from "./form0.vue?vue&type=template&id=3a6daf62&scoped=true"
import script from "./form0.vue?vue&type=script&lang=js"
export * from "./form0.vue?vue&type=script&lang=js"
import style0 from "./form0.vue?vue&type=style&index=0&id=3a6daf62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6daf62",
  null
  
)

export default component.exports